import { useEffect, useRef, useCallback } from 'react';
import gsap from 'gsap';

import useScrollStore from '../common/store/useScrollStore';
import useAnimationStore from '../common/store/useAnimationStore';

const useMasterTimeline = () => {
  const lockScroll = useScrollStore(useCallback(state => state.lockScroll, []));
  const unlockScroll = useScrollStore(useCallback(state => state.unlockScroll, []));

  const loading = useAnimationStore(useCallback(state => state.loading, []));

  const page = useAnimationStore(useCallback(state => state.landing.page, []));
  const mask = useAnimationStore(useCallback(state => state.landing.somersby.mask, []));
  const container = useAnimationStore(useCallback(state => state.landing.somersby.container, []));
  const title = useAnimationStore(useCallback(state => state.landing.somersby.title, []));
  const subtitle = useAnimationStore(useCallback(state => state.landing.somersby.subtitle, []));
  const fall = useAnimationStore(useCallback(state => state.landing.webgl.fall, []));
  const master = useRef(gsap.timeline());

  useEffect(() => {
    master.current
      .add(loading)
      .add(container)
      .add(title, "<")
      .add(subtitle)
      .add(mask, "<25%")
      .add(fall, "+=2")
      .add(page, "+=0.7");

    master.current.eventCallback("onStart", lockScroll);
    master.current.eventCallback("onComplete", unlockScroll);

    master.current.pause();
  }, []);

  return master;
}

export default useMasterTimeline;